import { limitPositionText } from './container';

$(document).on('keydown', '[data-update-orderapproval-position-text] textarea', function(event) {
  const change = limitPositionText(event, $(this).val());
  if (!change) {
    event.preventDefault();
    $(this).blur();
  }
  return change;
});
